var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Report"},[_c('div',{staticClass:"p-grid p-jc-center"},[_c('div',{staticClass:" p-col-12 p-md-9 p-lg-6  p-p-5 "},[_c('Reports')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }